import React, { createContext, Dispatch, RefObject, SetStateAction, useContext } from 'react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { DefaultVariableResult, VariableActionOption, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'

import { Option } from '@/shared/types'

// TODO (ACTION-WORKFLOWS): REFACTOR THIS
// Refactor to separate between variable select for normal and extended actions

export interface VariableSelectContextValue {
  id: string
  icon?: React.ReactNode
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  preventClose: boolean
  setPreventClose: Dispatch<SetStateAction<boolean>>
  onChange: (value?: DefaultVariableResult | DefaultVariableResult[]) => void
  featureFlags: VariableSelectFeatureFlag
  value?: DefaultVariableResult | DefaultVariableResult[]
  /*setValue: Dispatch<
   SetStateAction<undefined | DefaultVariableResult | DefaultVariableResult[]>
   >*/
  multiple: boolean
  forceUserSpecific: boolean
  variableActionOptions: {
    type: VariableActionOption
  }
  variableColumnOptions: {
    columnTypes: ColumnTypes[]
    excludeColIds: string[]
  }
  variableCustomTextOptions: {
    inputType: 'text' | 'number' | 'datetime'
    placeholder?: string
    validation?: (value: string) => void
  }
  inputRef: RefObject<HTMLInputElement>
  //dbId: string
  validation?: Record<VariableSelectFeatureFlag, (value: DefaultVariableResult) => void>
  limitType: {
    [key in VariableSelectFeatureFlag]?: number
  }
  tableId?: string
  options?: Option[]
  disableInput?: boolean
  flagOrder?: VariableSelectFeatureFlag[]
}

export const VariableSelectContext = createContext<VariableSelectContextValue>({
  id: '',
  open: false,
  setOpen: () => null,
  preventClose: false,
  setPreventClose: () => null,
  onChange: () => null,
  value: undefined,
  //setValue: () => null,
  multiple: false,
  featureFlags: 0 as VariableSelectFeatureFlag,
  forceUserSpecific: false,
  variableActionOptions: {
    type: VariableActionOption.None,
  },
  variableColumnOptions: {
    columnTypes: [],
    excludeColIds: [],
  },
  variableCustomTextOptions: {
    inputType: 'text',
  },
  inputRef: {
    current: null,
  },
  //dbId: '',
  validation: undefined,
  limitType: {},
  tableId: undefined,
  disableInput: false,
  flagOrder: undefined,
})

export function useVariableSelectContext() {
  return useContext(VariableSelectContext)
}
